"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImageUrlForUpload = exports.getImgUrl = exports.getImgUrlBase = exports.toCheckWebp = void 0;
var supportWebP_1 = require("./supportWebP");
var isCheckedWebP = false;
function toCheckWebp() {
    var wd = window || {};
    if (!isCheckedWebP) {
        if (!window.hasOwnProperty("isWebp")) {
            // 是否支持webp图片
            // @ts-ignore
            var supWbp = (0, supportWebP_1.supportWebP)();
            wd.isWebp = supWbp ? ".webp" : "";
            isCheckedWebP = true;
        }
    }
    return (wd === null || wd === void 0 ? void 0 : wd.isWebp) || "";
}
exports.toCheckWebp = toCheckWebp;
var getImgUrlBase = function (url, quality, iswebp, offect, prefix) {
    if (iswebp === void 0) { iswebp = true; }
    if (offect === void 0) { offect = {}; }
    if (prefix === void 0) { prefix = "//m.360buyimg.com/uba/"; }
    if (!url) {
        return url;
    }
    // 本地图片预览时候 是blob类型链接，不做处理
    var isBlob = /^blob:/g.test(url);
    if (isBlob) {
        return url;
    }
    var isBase64 = /^data:/g.test(url);
    if (isBase64) {
        return url;
    }
    var hasQuality = url.includes("!q");
    var hasDotWebP = url.includes(".webp");
    // 百分比压缩
    var initQuality = "";
    if (quality && !hasQuality) {
        initQuality = "!q".concat(quality);
    }
    var initIsWebp = iswebp && !hasDotWebP ? toCheckWebp() : "";
    if (/360buyimg/.test(url) || /image\.healthjd/.test(url)) {
        url = "jfs".concat(url.split("jfs")[1]);
    }
    else {
        var isHttp = /^((https:||http:)?\/\/)/i.test(url);
        if (isHttp || url.startsWith("//")) {
            return url;
        }
    }
    var originalwidth = offect.originalwidth, originalheight = offect.originalheight;
    var initSize = "";
    // 图片尺寸
    if (originalwidth || originalheight) {
        initSize = "s".concat(originalwidth ? originalwidth : "00", "x").concat(originalheight ? originalheight : "00", "_");
    }
    if (url.startsWith("/")) {
        url = url.slice(1);
    }
    return "".concat(prefix).concat(initSize).concat(url).concat(initQuality).concat(initIsWebp);
};
exports.getImgUrlBase = getImgUrlBase;
var getImgUrl = function (url, quality, iswebp, offect, prefix) {
    if (quality === void 0) { quality = 70; }
    if (iswebp === void 0) { iswebp = true; }
    if (offect === void 0) { offect = {}; }
    if (prefix === void 0) { prefix = "//m.360buyimg.com/uba/"; }
    return (0, exports.getImgUrlBase)(url, quality, iswebp, offect, prefix);
};
exports.getImgUrl = getImgUrl;
var getImageUrlForUpload = function (url, quality, iswebp, offect, prefix) {
    if (iswebp === void 0) { iswebp = true; }
    if (offect === void 0) { offect = {}; }
    if (prefix === void 0) { prefix = "//img30.360buyimg.com/nethpim/"; }
    return (0, exports.getImgUrlBase)(url, quality, iswebp, offect, prefix);
};
exports.getImageUrlForUpload = getImageUrlForUpload;
